export default __webpack_public_path__ + "static/media/Avenir-Medium.90ba4d31.ttf";